import { requestApi } from "../axios";

export function getList(limit, offset, search) {
  return requestApi(
    `/admin/admin-user/list?limit=${limit}&offset=${offset}${
      search?.trim() ? `&search=${encodeURIComponent(search?.trim() || "")}` : ""
    }`,
    "GET"
  );
}

export function createAccount(data) {
  return requestApi(`/admin/admin-user/create`, "POST", data);
}

export function updateAccount(data) {
  return requestApi(`/admin/admin-user/update/${data.id}`, "PATCH", data);
}

export function deleteAccount(id) {
  return requestApi(`/admin/admin-user/delete/${id}`, "DELETE");
}

export function getCurrentUserInfo() {
  return requestApi(`/admin/admin-user/me`, "GET");
}

export function requestforApproval(payload) {
  return requestApi(`/admin/admin-user/send-approve`, "POST", payload);
}

export function publishAccount(payload) {
  return requestApi(`/admin/admin-user/publish`, "POST", payload);
}

export function approveAccount(payload) {
  return requestApi(`/admin/admin-user/approve`, "POST", payload);
}

export function rejectAccount(payload) {
  return requestApi(`/admin/admin-user/reject`, "POST", payload);
}

export function skipOnBoarding() {
  return requestApi(`/admin/admin-user/skip-tour`, "POST");
}
